export const DA_TABLE_HEADERS_COLUMN = [
  { field: "small", id: "checkbox", label: "", table: 1 },
  { field: "small", id: "full_name", label: "Full Name" , table: 1 },
  { field: "small", id: "badge", label: "Badge", hasSort: true , table: 1 },
  { field: "small", id: "transporter_id", label: "Transporter ID", hasSort: true , table: 2 },
  { field: "small", id: "driver_license", label: "Driver License", hasSort: true, table: 2 },
  { field: "small", id: "mobile_number", label: "Mobile Number", hasSort: false , table: 2 },
  { field: "small", id: "email", label: "MYCU Email", hasSort: false , table: 2 },
  { field: "small", id: "personal_email", label: "Personal Email", hasSort: false , table: 2 },
  { field: "small", id: "status", label: "Status", hasSort: true , table: 2 },
  { field: "small", id: "status_change_reason", label: "Off-boarded Reason", hasSort: false , table: 2 },
  { field: "small", id: "created", label: "Onboarded", hasSort: true , table: 2 },
  { field: "small", id: "stations", label: "Station", hasSort: true , table: 2 },
  { field: "small", id: "payroll", label: "Payroll", hasSort: true , table: 2 },
  { field: "small", id: "fleet_groups", label: "Fleet Vendor", hasSort: true , table: 2 },
  { field: "small", id: "last_edit", label: "Last Updated", hasSort: true , table: 2 },
];

export const FLEET_TABLE_HEADERS_COLUMN = [
  { field: "small", id: "checkbox", label: "", table: 1 },
  { field: "small", id: "number", label: "Fleet No.", hasSort: true, table: 1 },
  { field: "small", id: "van_group", label: "Fleet Vendor", hasSort: true, table: 1 },
  { field: "small", id: "subtype", label: "Fleet Sub Vendor", hasSort: true, table: 2 },
  { field: "small", id: "fleet_size", label: "Fleet Size", hasSort: true, table: 2 },
  { field: "small", id: "plate_number", label: "Plate Number", hasSort: true, table: 2 },
  { field: "small", id: "status", label: "Status", hasSort: true, table: 2 },
  { field: "small", id: "status_change_reason", label: "Service Reason", hasSort: false, table: 2 },
  { field: "small", id: "pick_up_date", label: "Onboarded", hasSort: true, table: 2 },
  { field: "small", id: "station", label: "Station", hasSort: true, table: 2 },
  { field: "small", id: "ownership", label: "Ownership", table: 2 },
  { field: "small", id: "comment", label: "Comment", table: 2 },
  { field: "small", id: "last_edit", label: "Last Updated", hasSort: true, table: 2 },
];
